<template>
  <Dropdown :on-right="onRight" ref="dropdown">
    <DropdownItem
      :disabled="disabled"
      icon="customer"
      :navigate="
        '/customer/' + (this.order.customer ? this.order.customer.id : '')
      "
    >
      Go to customer
    </DropdownItem>
    <DropdownItem :disabled="disabled" icon="email" v-on:click="sendEmail()"
      >Send email to customer</DropdownItem
    >
    <DropdownSeparator />
    <DropdownItem
      v-on:click="sendPreshipping"
      :disabled="disabled || saving || order.realtime_styling_enabled"
      icon="preshipping"
    >Send Sneak Peek</DropdownItem
    >
    <DropdownItem
        v-on:click="$router.push('/preshipping/' + id)"
        :disabled="
          disabled
          || saving
        "
        icon="preshipping"
        >Sneak Peek</DropdownItem
      >
    <DropdownSeparator />
    <DropdownItem icon="outbound">
      Outbound
      <Dropdown>
        <DropdownItem
          v-on:click="execute('/outbound-order/' + id + '/verify')"
          :disabled="
            disabled ||
              saving ||
              !order.outbound.id ||
              order.outbound.verified_at
          "
          icon="outbound"
          >Verify outbound order</DropdownItem
        >
        <DropdownItem
          v-on:click="execute('/outbound-order/' + id + '/push-to-ftp')"
          :disabled="
            disabled ||
              saving ||
              !order.outbound.id ||
              !order.outbound.verified_at ||
              order.shipping.shipment
          "
          icon="export"
        >
          <template v-if="!order.outbound || !order.outbound.pushed_to_ftp_at"
            >Push outbound order</template
          >
          <template v-else>Push outbound order (again)</template>
        </DropdownItem>
        <DropdownSeparator />
        <DropdownItem
          v-on:click="
            execute('/order/' + id + '/rebuild', {
              target: 'woocommerce',
              source: 'products_table',
            })
          "
          :disabled="
            disabled ||
              saving ||
              order.outbound.pushed_to_ftp_at ||
              order.return_order.id
          "
          icon="rebuild"
        >
          Rebuild products table
        </DropdownItem>
        <DropdownItem
          v-on:click="
            execute('/order/' + id + '/rebuild', {
              target: 'products_table',
              source: 'woocommerce',
              hard: true,
            })
          "
          :disabled="
            disabled ||
              saving ||
              order.outbound.pushed_to_ftp_at ||
              order.return_order.id
          "
          icon="rebuild-hard"
        >
          Rebuild products table (hard)
        </DropdownItem>
        <DropdownSeparator />
        <DropdownItem
          v-on:click="
            execute('/order/' + id + '/outbound/synchronize/from-wordpress')
          "
          :disabled="disabled || saving || order.return_order.id"
          icon="synchronize"
        >
          Sync. from Woocommerce
        </DropdownItem>
      </Dropdown>
    </DropdownItem>
    <DropdownSeparator />
    <DropdownItem
      :disabled="disabled || !order.shipping.shipment"
      v-on:click="viewShipment('shipment')"
      icon="shipment"
      >View shipment label</DropdownItem
    >
    <DropdownItem
      :disabled="disabled || !order.shipping.return"
      v-on:click="viewShipment('return')"
      icon="return"
      >View return label</DropdownItem
    >
    <DropdownSeparator />
    <DropdownItem icon="return-order">
      Return order
      <Dropdown>
        <DropdownItem
          v-on:click="execute('/return-order/' + id + '/synchronize')"
          :disabled="
            disabled ||
              saving ||
              !order.return_order.id ||
              order.return_order.wp_sync_at
          "
          icon="clone"
        >
          Synchronize
        </DropdownItem>
        <DropdownItem
          v-on:click="execute('/return-order/' + id + '/synchronize?force=1')"
          :disabled="
            disabled ||
              saving ||
              !order.return_order.id ||
              order.return_order.wp_sync_at
          "
          icon="clone"
        >
          Synchronize (Force)
        </DropdownItem>
        <DropdownSeparator />
        <DropdownItem
          v-on:click="execute('/return-order/' + id + '/finalize')"
          :disabled="
            disabled ||
              saving ||
              !order.return_order.id ||
              !order.return_order.wp_sync_at ||
              order.return_order.finalized_at
          "
          icon="return-finalize"
          >Finalize return order</DropdownItem
        >
        <DropdownItem
          v-on:click="execute('/return-order/' + id + '/finalize?force=1')"
          :disabled="
            disabled ||
              saving ||
              !order.return_order.id ||
              !order.return_order.wp_sync_at ||
              order.return_order.finalized_at
          "
          icon="return-finalize-force"
          >Finalize return order (Force)</DropdownItem
        >
        <DropdownSeparator />
        <DropdownItem
          v-on:click="execute('/return-order/' + id + '/reset')"
          :disabled="
            disabled ||
              saving ||
              (!order.return_order.finalized_at &&
                !order.return_order.wp_sync_at)
          "
          icon="reset"
        >
          Reset
        </DropdownItem>
      </Dropdown>
    </DropdownItem>
    <DropdownSeparator />

    <DropdownItem icon="creditcard">
      Payment
      <Dropdown>
        <DropdownItem
          :disabled="disabled"
          v-on:click="openPaymentGateway()"
          icon="creditcard"
        >Open in payment gateway</DropdownItem
        >
        <DropdownSeparator />
        <DropdownItem
          :disabled="disabled"
          v-on:click="openPaymentLink()"
          icon="creditcard"
          >Payment link</DropdownItem
        >
        <DropdownItem
          :disabled="disabled || saving"
          v-on:click="sendPaymentLink()"
          icon="email"
          >Send payment link</DropdownItem
        >
        <DropdownSeparator />
        <DropdownItem
          :disabled="disabled || saving"
            v-on:click="recalculate('subscription-cost')"
            icon="subscription"
          >Recalc. subscription cost</DropdownItem>
        <DropdownItem
          v-on:click="recalculate('loyalty')"
          icon="loyalty"
        >Recalc. loyalty</DropdownItem>
        <DropdownItem
          v-on:click="recalculate('discount')"
          icon="discount"
        >Recalc. discount</DropdownItem>
      </Dropdown>
    </DropdownItem>

    <template v-if="associated_orders.length">
      <DropdownSeparator />
      <div v-for="associated_order in associated_orders">
        <DropdownItem
          v-on:click="$router.push('/order/' + associated_order.order_id)"
          :icon="orderTypeIcon(associated_order.order_type)"
        >
          Order {{ associated_order.order_id }} ({{
            orderType(associated_order.order_type)
          }})
        </DropdownItem>
      </div>
    </template>

    <DropdownSeparator />
    <DropdownItem
      :disabled="disabled || saving || order.order_type != 'styling-fee'"
      v-on:click="pick"
      icon="pick"
      >Pick</DropdownItem
    >
    <DropdownItem
      :disabled="disabled || order.order_type != 'styling'"
      v-on:click="goToStyling()"
      icon="loyalty"
      >Go to styling</DropdownItem
    >
    <DropdownItem
      :disabled="disabled || order.order_type != 'styling'"
      v-on:click="goToOutfits()"
      icon="preview"
    >Go to outfits</DropdownItem
    >
    <template v-slot:content>
      <template v-if="loading">
        Loading ...
      </template>
      <template v-if="order.id">
        <h2>Order {{ id }}</h2>
      </template>
    </template>
  </Dropdown>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    onRight: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    invoked: false,
    loading: false,
    saving: false,
    picking_id: false,
    order: {
      shipment: {}
    },
    associated_orders: []
  }),
  computed: {
    disabled () {
      return !this.order.id
    }
  },
  methods: {
    orderTypeIcon (orderType) {
      switch (orderType) {
        case 'styling':
        case 'styling-fee':
        case 'exchange':
          return orderType
        default:
          return 'order'
      }
    },
    orderType (orderType) {
      switch (orderType) {
        case 'styling':
          return 'Styling'
        case 'styling-fee':
          return 'Styling fee'
        case 'exchange':
          return 'Exchange'
        default:
          return orderType
      }
    },
    openPaymentLink () {
      window.open(this.order.payment_link.url)
    },
    pick () {
      const id = this.order.id
      this.picking_id = id
      Vue.api.get('/order/' + id + '/pick/preconditions', {}, {
        before: () => this.saving = true,
        callback: data => this.precondition(data)
      })
    },
    precondition (data) {
      this.saving = false
      if (!data.allow_pick) {
        const message = data.message
          ? 'The order cannot be picked. Reason: ' + data.message
          : 'The order cannot be picked'
        alert(message)
        return
      }

      if ((data.message && confirm(data.message + ' Continue?')) || !data.message) {
        Vue.api.post('/order/' + this.picking_id + '/pick', {}, {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: data => this.picked(data)
        })
      }
    },
    picked (data) {
      const id = data.id || data.ID
      const key = data.key
      this.$router.push({
        path: '/stylings/process',
        query: {
          id,
          key
        }
      })
    },
    recalculate (section) {
      Vue.$api.post(
        '/order/' + this.id + '/calculate/' + section,
        {},
        {
          loader: (toggle) => (this.saving = toggle),
          callback: () => {
            this.$store.commit('addMessage', {
              message: 'Done :-)'
            })
          }
        }
      )
    },
    sendPaymentLink () {
      Vue.$api.post(
        '/order/' + this.id + '/payment-link/send',
        {},
        {
          loader: (toggle) => (this.saving = toggle),
          callback: () => {
            this.$store.commit('addMessage', {
              message: 'Done :-)'
            })
          }
        }
      )
    },
    sendPreshipping() {
      Vue.api.get(
        `/order/${this.id}/preshipping-status`,
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: (res) => {
            if (res.show_popup && !confirm('Already sent. Do you want to send again?')) {
              return
            }
            this.sendGeneralPS()
          },
          error: (err) => {
            alert(err.data.message)
          }
        }
      )
    },
    sendGeneralPS () {
      Vue.api.get(
        `/warehouse/order/${this.id}/check-item-stock`,
        {},
        {
          before: () => this.saving = true,
          always: () => this.saving = false,
          callback: (res) => {
            Vue.api.patch(
              `preshipping/${this.id}/reset-flow`,
              {},
              {
                before: () => this.saving = true,
                always: () => this.saving = false,
                callback: (res) => {
                  Vue.api.post(
                    `order/${this.id}/send-preshipping-email`,
                    {},
                    {
                      before: () => this.saving = true,
                      always: () => this.saving = false,
                      callback: () => {
                        alert('Sneak peek sent.')
                      },
                      error: (error) => {
                        alert(error.data.message)
                      }
                    }
                  )
                },
                error: (error) => {
                  console.error('Error in SP reset flow: ', error)
                }
              }
            )
          },
          error: (error) => {
            if (error.data.error === 'products_out_of_stock') {
              loader.hide()
              this.showStockWarningModal(error.data.data)
            } else {
              alert(error.data.message)
            }
          }
        }
      )
    },
    execute (url, payload) {
      Vue.$api.post(url, payload || {}, {
        loader: (toggle) => (this.saving = toggle),
        callback: () => {
          this.$store.commit('addMessage', {
            message: 'Done :-)'
          })

          this.load(true)
        }
      })
    },
    goToStyling () {
      const hash = this.order.payment_link ? this.order.payment_link.hash : ''
      this.$router.push(
        '/stylings/process?id=' + this.order.id + '&key=' + hash
      )
    },
    goToOutfits () {
      window.open(this.order.outfits_url)
    },
    openPaymentGateway () {
      switch (Number(this.order.payment_provider.payment_provider_id)) {
        case 1:
          window.open(
            'https://dashboard.stripe.com/customers/' +
            this.order.customer.stripe_id
          )
          break
        case 2:
          window.open(
            'https://admin.billwerk.plus/#/rp/customers/customers/customer/' +
            this.order.customer.id
          )
          break
        default:
          throw Error('Unknown payment provider')
      }
    },
    viewShipment (type) {
      window.open(this.order.shipping[type].url)
    },
    sendEmail () {
      window.open('mailto:' + this.order.customer.email)
    },
    toggle () {
      this.$refs.dropdown.toggle()

      this.load()
    },

    /**
     * Load information about the order
     *
     * @param {Boolean} force
     * @return void
     */
    load (force) {
      if (!this.invoked || force) {
        this.invoked = true

        Vue.$api.get(
          '/order/' + this.id + '/quick-access',
          {},
          {
            loader: (toggle) => (this.loading = toggle),
            callback: (data) => this.parse(data)
          }
        )
      }
    },

    parse (data) {
      this.order = data
      this.associated_orders = data.associated_orders
    }
  }
}
</script>
